import React, { useState } from 'react';
import { Text, Badge, Tr, Td } from '@chakra-ui/react';
import ProductMenuAdmin from '../../components/ProductMenuAdmin';
import { setItemAvailability, setItemMaxQuantity } from '../../api';
import { ModalInput } from '../../components/ModalInput';

function ProductStatus({
  productId,
  title,
  isAvailable,
  paid,
  cashier,
  qtyForDate,
  isCombo,
  refDate,
  onMaxUpdate,
}) {
  const [localIsAvailable, setLocalIsAvailable] = useState(undefined);

  const [showModalInput, setShowModalInput] = useState(false);
  const [currentMaxQuantityId, setCurrentMaxQuantityId] = useState(undefined);

  // only for products
  const setMaxQuantityModal = (id) => {
    setShowModalInput(true);
    setCurrentMaxQuantityId(id);
  };
  const setMaxQuantity = async (id, quantity) => {
    const res = await setItemMaxQuantity(id, quantity, refDate);
    if (res.success) {
      onMaxUpdate();
    }
  };

  const setUnavailable = async (id, isProduct) => {
    const res = await setItemAvailability(id, isProduct, false);
    if (res.success) {
      setLocalIsAvailable(false);
    }
  };

  const setAvailable = async (id, isProduct) => {
    const res = await setItemAvailability(id, isProduct, true);
    if (res.success) {
      setLocalIsAvailable(true);
    }
  };
  const isAvailableTotal = localIsAvailable !== undefined ? localIsAvailable : isAvailable;
  // const qtyForDateTotal = localMaxQuantity !== undefined ? localMaxQuantity : qtyForDate;

  const color = paid.quantity !== 0 || cashier.quantity ? 'gold' : 'white';

  return (
    <Tr>
      <Td px={0}>
        <ProductMenuAdmin
          id={productId}
          isProduct={!isCombo}
          isAvailable={isAvailableTotal}
          setUnavailable={setUnavailable}
          setAvailable={setAvailable}
          setMaxQuantityModal={setMaxQuantityModal}
        />
      </Td>
      <Td px={1} minW='80px' maxW='120px'>
        <Text 
          // fontSize='12px'
          wordBreak='break-word'
          whiteSpace='normal'
          lineHeight='1.2'
        >
          {title}
          {!isAvailableTotal && (
            <Text mt={1}>
              <Badge borderRadius={5} colorScheme='red' fontSize='10px'>
                Non disponibile
              </Badge>
            </Text>
          )}
        </Text>
      </Td>
      <Td px={1} textAlign={'center'} color={color} >
        {qtyForDate}
      </Td>
      <Td px={1} textAlign={'center'} color={color}>
        {paid.delivered + cashier.delivered}
      </Td>
      {/* PAGATI */}
      <Td px={1} textAlign={'center'} color={color}>
        {paid.quantity}
      </Td>
      {/* ADMIN */}
      <Td px={1} textAlign={'center'} color={color}>
        {cashier.quantity}
      </Td>
      {/* % */}
      {/* <Td px={1} textAlign={'center'} color={color}>
        {perc(paid.delivered+cashier.delivered, paid.quantity + cashier.quantity)}%
      </Td> */}
      <Td px={1} textAlign={'center'} color={color}>
        {cashier.quantity + paid.quantity - (paid.delivered + cashier.delivered)}
      </Td>
      <ModalInput
        isOpen={showModalInput}
        title='Imposta Disponibilità Massima'
        body='Inserisci un valore'
        onCancel={() => {
          setShowModalInput(false);
        }}
        onClose={(_max) => {
          setShowModalInput(false);
          setMaxQuantity(currentMaxQuantityId, _max);
        }}
      />
    </Tr>
  );
}

export default ProductStatus;
